<template>
    <v-container class="pa-0 ma-0" fluid flat style="width: 100%">

        <v-toolbar v-if="!undermanagement" id="exploretool" style="overflow:hidden" color="#FFA500" flat dense class="pb-0">
            <v-toolbar-items>
                <v-btn class="mx-0" text @click="setnavbar" color="black"><v-icon>menu</v-icon></v-btn>
                <div class="pa-1 mx-5 black--text menuhead" text tile>SHARE</div>
                <v-btn icon @click='addNew()'>
                    <v-icon color="black">add_circle</v-icon>
                </v-btn>
                <v-menu class="pa-0 ma-0" flat offset-y :key="this.$store.state.updatecount">
                    <template v-slot:activator="{ on }">
                        <v-btn :disabled=noShares color="#FFA500" class="py-0 my-0" v-on="on"><v-icon color="black" class="pr-5 mr-0">filter</v-icon>{{filtertitle}}</v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-for="(item, index) in filteritems" :key="index" @click="setFilter(item)">
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-menu class="pa-0 ma-0" flat offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn :disabled=noShares color="#FFA500" class="py-0 my-0" v-on="on"><v-icon color="black" class="pr-5 mr-0">sort</v-icon>{{sorttitle}}</v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-for="(item, index) in sortitems" :key="index" @click="setSort(item)">
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar-items>
        </v-toolbar>


        <v-card flat color="#FFD375">

            <v-card v-if="undermanagement" flat color="#FFD375">
                <v-container class="pa-2 ma-2" style="height: 5%;">

                    <v-menu class="pa-0 ma-0" style="position:absolute; left:45px; top:100px;" flat offset-y :key="this.$store.state.updatecount">
                        <template v-slot:activator="{ on }">
                            <v-btn :disabled=noShares color="#FFA500" class="py-0 my-0" v-on="on"><v-icon color="black" class="pr-5 mr-0">filter</v-icon>{{filtertitle}}</v-btn>
                        </template>
                        <v-list>
                            <v-list-item v-for="(item, index) in filteritems" :key="index" @click="setFilter(item)">
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>

                    <v-menu class="pa-0 ma-0" style="position:absolute; left:255px; top:100px;" flat offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn :disabled=noShares color="#FFA500" class="py-0 my-0" v-on="on"><v-icon color="black" class="pr-5 mr-0">sort</v-icon>{{sorttitle}}</v-btn>
                        </template>
                        <v-list>
                            <v-list-item v-for="(item, index) in sortitems" :key="index" @click="setSort(item)">
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
         
                </v-container>
            </v-card>

            <v-card class="pa-0 my-5" flat style="width: 600px" tile>
                <v-list two-line class="bckgrnd pa-0 ma-0" flat>
                    <v-content>
                        <v-list-item-group v-model="item" color="#FFD375">
                            <v-list-item v-for="(share, i) in shares" :key="i">
                                <v-row :class='rowClass(share)' @click='rowClicked(share)'>
                                    <v-col cols="7">
                                        <v-list-item-content>
                                            <v-list-item-title class="boldtext" v-text="share.Name"></v-list-item-title>
                                            <v-list-item-subtitle class="smalltext" v-text="shareDetail(share)"></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col cols="5" class="text-right">
                                        <v-container>
                                            <v-list-item-icon v-if="isMyShareSelected(share)" class="px-2 py-0 ma-0" @click='editClicked()'>
                                                <v-icon color="#000000">account_tree</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-icon v-if="share.IsSelected" class="px-2 py-0 ma-0" @click='deleteClicked()'>
                                                <v-icon color="#000000">delete_forever</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-icon v-if="isMyShareSelectedAndContacts(share)" class="px-2 py-0 ma-0" @click='shareClicked(share)'>
                                                <v-icon color="#000000">share</v-icon>
                                            </v-list-item-icon>
                                        </v-container>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                        </v-list-item-group>
                    </v-content>
                </v-list>
            </v-card>

            <SharePopup v-bind:selectedshare=selectedshare v-model="showSharePopup" />
        </v-card>
    </v-container>
</template>

<script>

    import SharePopup from '@/views/Manage/Shares/SharePopup';
    import firebase from 'firebase';
    import { dateticks, firebaseid, sharename, getfirebaseid, getshareparticipants } from '@/functions.js';

    export default {
        mounted: function () {
            selectedshare: null,
            this.populateScreen();       
        },
        data: () => ({
            sortitems: [
                { title: 'Latest first', prop: 'Name', dir: 'Down'},
                { title: 'Earliest first', prop: 'Name', dir: 'Up' },
                { title: 'Un-shared first', prop: 'ShareTime', dir: 'Up' },
                { title: 'Shared first', prop: 'ShareTime', dir: 'Down' }
            ],
            sorttitle: 'Sort...',
            filteritems: [],
            filtertitle: 'Show all shares',
            item: null,
            groupdata: {},
            shares: [],
            xparam: { title: 'Latest first', prop: 'Name', dir: 'Down' },
            selectedshare: null,
            showSharePopup: false,
        }),
        components: {
            SharePopup,
        },
        methods: {
            populateScreen() {
                this.shares = [];
                this.$store.state.shares.forEach(share => {
                    share.IsSelected = false;
                    this.shares.push(share);
                });
                if (this.$store.state.onlymyshares) {
                    this.filteritems = [
                        { title: 'Show all my shares' },
                        { title: 'Show my shared' },
                        { title: 'Show my un-shared' }
                    ];
                    this.$store.state.updatecount++;
                    this.setFilter({ title: 'Show all my shares' });
                }
                else {
                    this.filteritems = [
                        { title: 'Show all shares' },
                        { title: 'Show shared' },
                        { title: 'Show un-shared' }
                    ];
                    this.$store.state.updatecount++;
                    this.setFilter({ title: 'Show all shares' });
                }   
            },
            addNew() {
                this.selectedshare = new Object();
                var ticks = dateticks();
                this.selectedshare.CreatorID = this.$store.state.user.uid;
                this.selectedshare.Name = sharename(this.$store.state.currentuser.Tag);
                this.selectedshare.ShareTime = 0;
                this.selectedshare.ID = firebaseid(ticks);
                this.showSharePopup = true;
            },
            setnavbar() {
                this.$store.state.navpage.setnavbar();
            },
            isMyShare(share) {
                if (share.CreatorID === this.$store.state.user.uid) {
                    return true;
                }
                else {
                    return false;
                }
            },
            isMyShareSelected(share) {
                if ((this.isMyShare(share)) && (share.IsSelected))
                    return true;
                else
                    return false;
            },
            isMyShareSelectedAndContacts(share) {
                if ((share.Contacts == null) && (share.Groups == null))
                    return false;
                if ((this.isMyShare(share)) && (share.IsSelected))
                    return true;
                else
                    return false;
            },
            meetsFilter(share) {
                if (this.filtertitle === "Show all shares")
                    return true;
                if (this.filtertitle === "Show all my shares") {
                    if (this.isMyShare(share))
                        return true;
                }
                if (this.filtertitle === "Show un-shared") {
                    if (share.ShareTime == 0)
                        return true;
                }
                if (this.filtertitle === "Show shared") {
                    if (share.ShareTime > 0)
                        return true;
                }
                if (this.filtertitle === "Show my un-shared") {
                    if ((this.isMyShare(share)) && (share.ShareTime == 0))
                        return true;
                }
                if (this.filtertitle === "Show my shared") {
                    if ((this.isMyShare(share)) && (share.ShareTime > 0))
                        return true;
                }
                return false;
            },
            shareDetail(share) {
                var str = "( ";
                if (this.isMyShare(share)) {
                    if (share.Contacts == null) {
                        str += "0 contacts";
                    }
                    else {
                        str += share.Contacts.length + " contact";
                        if (share.Contacts.length != 1) {
                            str += "s";
                        }
                    };
                    str += ", ";
                    if (share.Groups == null) {
                        str += "0 groups";
                    }
                    else {
                        str += share.Groups.length + " group";
                        if (share.Groups.length != 1) {
                            str += "s";
                        }
                    };
                    str += ", ";
                }

                str ="(15 contacts, "
                if (share.Survey == null) {
                    str += "0 media items (0 MB)";
                }
                else {
                    str += "24 media items (1236 MB)";
                    str += ", 15 alerts";
                };
                str += " )";
                return str;
            },
            setFilter(param) {
                this.filtertitle = param.title;
                this.shares = [];
                this.$store.state.shares.forEach(share => {
                    if (this.meetsFilter(share)) {
                        this.shares.push(share);
                    }
                });
                this.setSort(this.xparam);
            },
            setSort(param) {
                this.sorttitle = "Sort by " + param.title;
                this.xparam = param;
                if (param.dir === 'Up')
                    this.shares.sort((a, b) => a[this.xparam.prop] < b[this.xparam.prop] ? -1 : 1);
                else
                    this.shares.sort((a, b) => a[this.xparam.prop] > b[this.xparam.prop] ? -1 : 1);
            },
            rowClicked(share) {
                if (this.selectedshare != null)
                    this.selectedshare.IsSelected = false;
                share.IsSelected = true;
                this.selectedshare = share;
                this.$store.state.selectedshare = share;
            },
            editClicked() {
                this.showSharePopup = true;
            },
            deleteClicked() {
                this.$root.$confirm('Confirm', 'Are you sure you want to delete this share?', { color: '#FFA500' }).then((confirm) => {
                    if (confirm) {
                        this.$store.dispatch('cutShare', this.selectedshare);
                    }
                })
            },
            findMySurvey(id) {
                var found = null;
                this.$store.state.surveys.forEach(survey => {
                    if (survey.ID === id)
                        found = survey;
                });
                return found;
            },
            distributeShare(share,contact,tags,st) {
                //alert("distribute " + contact.Registered);
                this.$store.state.surveys.forEach(survey => {
                    if (survey.ID === share.Survey) {            
                        var sur = { Remote: true, DatabaseID: this.$store.state.databaseid, CreatorID: this.$store.state.user.uid, Name: survey.Name, MediaCount: survey.MediaCount, MediaSize: survey.MediaSize };
                        var shr = { ShareTime:st, DatabaseID: this.$store.state.databaseid, CreatorID: this.$store.state.user.uid, Name: share.Name, Survey: share.Survey};
                        firebase.database().ref('databases/' + contact.DatabaseID + '/users/' + contact.Registered + '/mydata/myshares/' + share.ID).set(shr);
                        firebase.database().ref('databases/' + contact.DatabaseID + '/users/' + contact.Registered + '/mydata/mysurveys/' + share.Survey).set(sur);
                        for (var tkey in tags) {
                            var tag = tags[tkey];
                            tag.SurveyID = share.Survey;
                            firebase.database().ref('databases/' + contact.DatabaseID + '/users/' + contact.Registered + '/tags/' + tkey).set(tag);
                        }           
                   }
                });
            },
            shareClicked(share) {
                var distributioncount = 0;
                var thisthis = this;
                var survey = this.findMySurvey(share.Survey);
                this.$store.state.exploresurvey = survey;
                this.$root.$confirm('Activate', 'Are you sure you want to activate this share?', { color: '#FFA500' }).then((confirm) => {
                    if (confirm) {
                        var st = getfirebaseid();
                        var dbid = this.$store.state.databaseid;
                        var uid = this.$store.state.user.uid;
                        firebase.database().ref('databases/' + dbid + '/users/' + uid + '/mydata/myshares/' + share.ID + "/ShareTime").set(st);
                        var tags = {};
                        var tagcount = 0;
                        for (var tkey in this.$store.state.mytags) {
                            var tag = this.$store.state.mytags[tkey];
                            if (tag.SurveyID === share.Survey) {
                                tags[tkey] = { Total: tag.Total, Rating: tag.Rating , Read: 0 };
                                tagcount++;
                            }
                        };
                        //alert("got tags");
                        if (tagcount > 0) {
                            //must generate a list of individuals from contacts and groups and then 
                            var participants=getshareparticipants(share);
                            participants.forEach(id => {
                                thisthis.$store.state.contacts.forEach(contact => {
                                    if (contact.ID === id) {
                                        if (contact.Registered != null) {
                                            thisthis.distributeShare(share, contact, tags,st);
                                            distributioncount++;
                                        }
                                    }
                                });
                            });

                            if (distributioncount == 0)
                                thisthis.$root.alertm('Alert', "Share not possible - 0 registered users", { color: '#FFA500' }).then((confirm) => { });
                            if (distributioncount == 1)
                                thisthis.$root.alertm('Alert', "Share complete - 1 user notified", { color: '#FFA500' }).then((confirm) => { });
                            if (distributioncount > 1)
                                thisthis.$root.alertm('Alert', "Share complete - " + distributioncount + " users notified", { color: '#FFA500' }).then((confirm) => { });
                        }
                    }
                })
            },
            rowClass(share) {
                if (share.IsSelected)
                    return 'selectedtile';
                else {
                    if (this.isMyShare(share))
                        return 'greentile';
                    else
                        return 'pinktile';
                }
            },
        },
        computed: {
            undermanagement() {
                return this.$store.state.undermanagement;
            },
            noShares() {
                if (!this.$store.state.shares)
                    return true;
                if (this.$store.state.shares.length < 1)
                    return true;
                else
                    return false;
            },
            sharecount() {
                return this.$store.state.shares.length;
            }
        },
        watch: {
            sharecount() {
                this.populateScreen();
            }
        }
    }
</script>

<style scoped>
    .tile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        border-color: black;
        background: #FFD375;
    }

        .tile:hover {
            background: #FFC733;
        }

    .tile:active {
        background: yellow;
    }

    .selectedtile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        background: #FFA500;
    }

    .greentile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        background: #86F499;
    }

    .pinktile {
        margin: 0px;
        padding: 0px;
        margin-top: 0px;
        margin-bottom: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        background: #F49C86;
    }

    .bckgrnd {
        background: #FFD375;
    }

    .boldtext {
        color: black;
        font-size: large;
        font-weight: bold;
    }

    .smalltext {
        color: darkslategray;
        font-size: small;
        margin-top: 4px;
    }

    .menuhead {
        font-size: 1.5em;
        font-weight: bold;
    }
</style>

